import React from "react";
import {
  ContentfulRichTextGatsbyReference,
  renderRichText,
  RenderRichTextData,
} from "gatsby-source-contentful/rich-text";
import { INLINES, BLOCKS, MARKS } from "@contentful/rich-text-types";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { HeadingMedium, HeadingSmall, ParagraphMomento } from "@tumomento/ui";
import "./PostRichText.scss";

export interface IPropsRichText {
  richText: RenderRichTextData<ContentfulRichTextGatsbyReference>;
}

const options = {
  renderMark: {
    [MARKS.BOLD]: (text: any) => <b className="boldRichText">{text}</b>,
    [MARKS.ITALIC]: (text: any) => <i className="italicRichText">{text}</i>,
    [MARKS.UNDERLINE]: (text: any) => (
      <u className="underlineRichText">{text}</u>
    ),
    /*     [MARKS.CODE]: (text: any) => (
          <code className="font-mono px-1 py-2 mx-1 bg-gray-100 rounded text-sm">
            {text}
          </code>
        ), */
  },
  renderNode: {
    [INLINES.HYPERLINK]: (node: any, children: any) => {
      let href = node.data.uri;      
      if (!href.startsWith("http://") && !href.startsWith("https://")) {
        href = "https://" + href;
      }
      return (
        <a href={href} target="_blank" className="linkRichText">
          {children}
        </a>
      );
    },
    [BLOCKS.HEADING_1]: (node: any, children: any) => (
      <>
        <HeadingMedium typography="heading-l">{children}</HeadingMedium>
        <br />
      </>
    ),
    [BLOCKS.HEADING_2]: (node: any, children: any) => {
      return (
        <>
          <HeadingMedium
            id={
              (node.content as any[]).reduce(
                (acc, d) =>
                  acc + ((d.value ?? "") as string).trimStart().trimEnd(),
                ""
              ) as string
            }
            className="h2-rich"
          >
            {children}
          </HeadingMedium>
          <br />
        </>
      );
    },
    [BLOCKS.HEADING_3]: (node: any, children: any) => (
      <>
        <HeadingSmall>{children}</HeadingSmall>
        <br />
      </>
    ),

    [BLOCKS.OL_LIST]: (node: any, children: any) => (
      <ol className="listRichTExt">{children}</ol>
    ),
    [BLOCKS.UL_LIST]: (node: any, children: any) => (
      <ul className="listRichTExt">{children}</ul>
    ),

    [BLOCKS.LIST_ITEM]: (node: any, children: any) => (
      <li className="listItemRichText">{children}</li>
    ),
    [BLOCKS.PARAGRAPH]: (node: any, children: any) => {
      if (node.content[0].value === `` || node.content[0].value === `\n`) {
        return <br />;
      } else {
        return (
          <>
            <ParagraphMomento className="paragraphRichTech" color="content1">
              {children}
            </ParagraphMomento>
            <br />
          </>
        );
      }
    },
    [BLOCKS.QUOTE]: (children: any) => (
      <>
        <blockquote className="blockquoteRichTech">
          <>{`"${children.content[0].content[0].value}"`}</>
        </blockquote>
        <br />
      </>
    ),
    [BLOCKS.HR]: () => <hr />,
    [BLOCKS.EMBEDDED_ASSET]: (node: any) => {
      const { gatsbyImageData = null, description, title } = node.data.target;
      const image = gatsbyImageData ?? getImage(gatsbyImageData);
      return (
        <>
          {image && (
            <GatsbyImage
              className="imageRichText"
              image={image}
              alt={
                description ?? `imagen ${title ?? description ?? "de árticulo"}`
              }
            />
          )}
        </>
      );
    },
  },
};

export const PostRichText = ({ richText }: IPropsRichText) => {
  return (
    <div className="wrapRichTech">{renderRichText(richText, options)}</div>
  );
};
